import React, { useEffect, useRef } from "react"
import type { GatsbyBrowser } from "gatsby"
import { Provider } from "@/services/Provider"
import { initializeApp } from "firebase/app"
import { initializeFirestore, Timestamp } from "firebase/firestore"
import { toast, Toaster } from "sonner"
import { RefreshCcw } from "lucide-react"
//@ts-ignore
import { Button } from "@/components/ui/button"
import "./src/global.css"

const app = initializeApp({
  apiKey: process.env.GATSBY_FIREBASE_API_KEY,
  authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.GATSBY_FIREBASE_DATABASE_URL,
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.GATSBY_FIREBASE_APP_ID,
})
initializeFirestore(app, {
  // localCache: persistentLocalCache(),
})

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = options => {
  const { element, props } = options
  const ref = useRef<any>(null)
  useEffect(() => {
    document.addEventListener("app-update", () => {
      // toast("Update Available", {
      //   description:
      //     "The app has been updated. Please reload to see the latest changes.",
      // })
      localStorage.setItem("update", "true")
      ref.current = toast("Update Available", {
        description: (
          <div>
            <p>
              The app has been updated. Please reload to see the latest changes.
            </p>
            <div className="flex justify-end">
              <Button
                variant={"secondary"}
                onClick={() => {
                  localStorage.removeItem("update")
                  window.location.reload()
                }}
              >
                <RefreshCcw /> Update
              </Button>
            </div>
          </div>
        ),
      })
    })
    return () => {
      toast.dismiss(ref.current)
    }
  }, [])
  useEffect(() => {
    if (localStorage.getItem("update")) {
      ref.current = toast("Update Available", {
        description: (
          <div>
            <p>
              The app has been updated. Please reload to see the latest changes.
            </p>
            <div className="flex justify-end">
              <Button
                variant={"secondary"}
                onClick={() => {
                  localStorage.removeItem("update")
                  window.location.reload()
                }}
              >
                <RefreshCcw /> Update
              </Button>
            </div>
          </div>
        ),
      })
    }
    return () => {
      toast.dismiss(ref.current)
    }
  })
  // <Button className="">
  //         <RefreshCcw />
  //         Update
  //       </Button>
  return (
    <Provider {...props}>
      <Toaster
        className="flex flex-col"
        closeButton
        position="top-right"
        duration={Infinity}
        // duration={5000}
      />
      {element}
    </Provider>
  )
}
export const onServiceWorkerUpdateReady = async () => {
  try {
    document.dispatchEvent(new CustomEvent("app-update", { bubbles: true }))

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          registration.unregister()
        }
      })
    }
  } catch (e) {
    alert(JSON.stringify(e))
  }
}
